import Mithril from 'mithril';
import { extend } from 'flarum/common/extend';
import LinkButton from 'flarum/common/components/LinkButton';
import Component, { ComponentAttrs } from 'flarum/common/Component';
import IndexPage from 'flarum/forum/components/IndexPage';
import Button from 'flarum/common/components/Button';
import app from 'flarum/forum/app';

class AllButton extends Component {
  view(vnode: Mithril.Vnode<ComponentAttrs, this>): Mithril.Children {
    return (
      <LinkButton href="/all" icon="fas fa-comments" title="主题">
        主题
      </LinkButton>
    );
  }
}

export default function () {
  /**
   * @since 2024-05-03
   * 点击全部主题跳转到/all页面, 首页现在重定向到/tags页面
   *
   * @deprecate 弃用，可以在后台管理选择板块页面为首页
   */
  // app.routes.all = { path: '/all', component: IndexPage };
  // extend(IndexPage.prototype, 'navItems', function (items) {
  //   const allDiscussions = items.get('allDiscussions');
  //   if (allDiscussions) {
  //     allDiscussions.attrs.onclick = (event: Event) => {
  //       m.route.set('/all');
  //       event.preventDefault();
  //     };
  //   }
  // });
  /**
   * 首页更改为板块页，原板块tab改为全部主题
   *
   * @deprecated 2024-08-11 弃用，更改回去
   */
  // extend(Application.prototype, 'mount', function () {
  //   setTimeout(() => {
  //     const tagTab: HTMLLinkElement | null = document.querySelector('.MobileTab-items .item-tags');
  //
  //     if (!tagTab) return;
  //
  //     tagTab.childNodes[0].remove();
  //
  //     m.mount(tagTab, AllButton);
  //   }, 0);
  // });

  extend(IndexPage.prototype, 'navItems', function (items) {
    items.add(
      'about-the-company',
      <LinkButton icon="fas fa-comments" href='d/1-guan-li-gui-ding' title ="关于公司">
        关于公司
      </LinkButton>,
      -10
    );
  });

  extend(IndexPage.prototype, 'viewItems', function (items) {
    const sortMap = app.discussions.sortMap();
    const currentSort = app.search.params().sort || Object.keys(sortMap)[0];
    const currentPathname = window.location.pathname;

    items.remove('sort');

    items.add(
      'latest',
      <Button
        className="Button"
        active={currentSort === 'latest' && currentPathname === '/'}
        onclick={() => {
          if (currentPathname === '/following') {
            m.route.set('/');
          } else {
            app.search.changeSort('latest');
          }
        }}
      >
        最新
      </Button>
    );
    items.add(
      'top',
      <Button
        // line feed
        className="Button"
        active={currentSort === 'top' && currentPathname === '/'}
        onclick={() => {
          if (currentPathname === '/following') {
            m.route.set('/?sort=top');
          } else {
            app.search.changeSort('top');
          }
        }}
      >
        热门
      </Button>
    );
    items.add(
      'following',
      <Button
        className="Button"
        active={currentPathname === '/following'}
        onclick={() => {
          m.route.set('/following');
        }}
      >
        关注
      </Button>
    );
  });
}
